module.exports = __webpack_public_path__ + "images/bug_purple_size_4_f94f208cf8180112319ef6ec6b76bb34.png";